import styles from "./NavBar1.module.css";
import Logo from "../../assets/images/logo.png";
import SearchBar from "../UI/SearchBar/SearchBar";
import * as actions from "../../store/actions/index";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import React, { useEffect } from "react";
const NavBar1 = (props) => {
  const handleAuth = () => {
    if (props.user) {
      props.logout();
      window.location.reload();
    } else {
      props.history.replace("/authentication");
    }
  };

  useEffect(() => {
    if (props.user) {
      props.onSetCart(props.user);
    }
  }, [props.user]);

  const getCartCount = () => {
    let quantity = 0;
    let products = props.order.products;
    for (let i = 0; i < products.length; i++) {
      quantity += products[i].quantity;
    }
    return quantity;
  };
  return (
    <div className={styles.Navbar}>
      <nav
        className="navbar navbar-light bg-light "
        style={{
          padding: "0px 10px",
          justifyContent: "space-evenly",
          flexWrap: "nowrap",
        }}
      >
        <div className={styles.Social}>
          <i className="fa fa-facebook-square"></i>
          <i className="fa fa-youtube-play"></i>
          <i className="fa fa-instagram"></i>
          <i className="fa fa-twitter"></i>
        </div>
        <a
          className="navbar-brand"
          onClick={() => props.history.replace("/")}
          style={{ cursor: "pointer" }}
        >
          <img width="100px" src={Logo} alt=""></img>
        </a>

        {document.body.clientWidth >= 768 ? <SearchBar /> : null}

        <div className={styles.Account}>
          {props.user ? (
            <div className="dropdown show" style={{ cursor: "pointer" }}>
              <i
                className="fa fa-user dropdown-toggle"
                id="dropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></i>
              {/* <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Dropdown link
                      </a> */}

              <div
                className="dropdown-menu dropdown-menu-right "
                aria-labelledby="dropdownMenuLink"
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    props.logout();
                    window.location.reload();
                  }}
                >
                  Log Out
                </a>
                {props.user && (
                  <a
                    className="dropdown-item"
                    onClick={() => props.history.push("/myBookings")}
                  >
                    My Orders
                  </a>
                )}
                {props.user && (
                  <a
                    className="dropdown-item"
                    onClick={() => props.history.push("/wishlist")}
                  >
                    Wishlist
                  </a>
                )}
                {/* <a className="dropdown-item" onClick={()=>alert("Action")}>Something else here</a> */}
              </div>
            </div>
          ) : (
            <>
              <div className="navbar-buttons mbr-section-btn">
                <button className="btn btn-primary btn-sm" onClick={handleAuth}>
                  {props.user ? "Logout" : "Login/Register"}
                </button>
              </div>
            </>
          )}
          {props.user && (
            <i
              className="fa fa-shopping-cart d-flex"
              style={{ cursor: "pointer" }}
              onClick={() => props.history.push("/cart")}
            >
              <span className="badge badge-warning ml-2">{getCartCount()}</span>
            </i>
          )}
        </div>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    order: state.cart.order,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    onSetCart: (user) => dispatch(actions.setCart(user)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavBar1)
);
